<section class="section-selection">
    <div class="backdrop"></div>
    <div class="content">
        <div class="intro">
            <p class="eyebrow">{{ 'sectionSelection.eyebrow' | translate }}</p>
            <h1>{{ 'sectionSelection.title' | translate }}</h1>
            <p class="lede">{{ 'sectionSelection.subtitle' | translate }}</p>
        </div>

        <div class="options">
            <button class="option option--tool"
                    type="button"
                    *ngIf="hasToolSection"
                    (click)="selectSection('tool')">
                <img class="option__icon" src="assets/icons/section-tool.svg" alt="" aria-hidden="true">
                <div class="option__header">
                    <span class="option__title">{{ 'sectionSelection.tool.title' | translate }}</span>
                </div>
                <p class="option__description">{{ 'sectionSelection.tool.description' | translate }}</p>
            </button>

            <button class="option option--strain"
                    type="button"
                    *ngIf="hasStrainSection"
                    (click)="selectSection('strain')">
                <img class="option__icon" src="assets/icons/section-strain.svg" alt="" aria-hidden="true">
                <div class="option__header">
                    <span class="option__title">{{ 'sectionSelection.strain.title' | translate }}</span>
                </div>
                <p class="option__description">{{ 'sectionSelection.strain.description' | translate }}</p>
            </button>
        </div>
    </div>
</section>
